<template>
  <div class="app">
    <!-- 顶部导航栏 -->
    <Header />

    <!-- 路由内容 -->
    <main class="main-content">
      <router-view></router-view>
    </main>

    <!-- 底部信息 -->
    <Footer />
  </div>
</template>

<script setup lang="ts">
import Header from "./Hearder/index.vue";
import Footer from "./Footer/index.vue";
</script>

<style scoped>
.app {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  color: #333;
  background-color: #f8f9fa;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

</style>
